
import React, { useEffect, useMemo, useState } from 'react';
import DataGrid, { SelectColumn } from 'react-data-grid';
import isNull from '../../../utils/NullChecking';
import ReactDataGrid from 'react-data-grid';
import Loader from '../Loader/Loader';
import { ServerRequestProtected } from '../../../utils/ServerDataRequest';
import { enumUtil } from '../../../utils/Enum';
// import NoDataFound from "./../../../assets/img/NoDataFound.svg"
import 'react-data-grid/lib/styles.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css'; // theme css file
import NoDataFound from '../NoDataFound/NoDataFound';
import { useSelector } from 'react-redux';
const DataTable = (props) => {
    let GridView = useSelector(state => state.SettingsReducer);
    const API_URL = enumUtil.controller.General
    const [tableColumns, setTableColumns] = useState([])
    const [optionTbaleColumns, setoptionTbaleColumns] = useState([])
    const [loadingMoreRows, setLoadingMoreRows] = useState(false)
    const [noRows, setNoRows] = useState(false)
    const [previousRows, setPreviousRows] = useState([])
    const [pageNo, setPageNo] = useState(1)
    const [sortColumns, setSortColumns] = useState([]) // columnKey,direction
    const [Row1, setRow1] = useState(props.rows)
    const rows = props.rows?.slice(0)
    const [visibleColumns, setVisibleColumns] = useState();
    const [copyCols, setCopyCols] = useState()
    const [ColumnNames, setColumnNames] = useState([])
    const [ColumnID, setColumnID] = useState('0')
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        //add selectCheckbox column in grid
        setRow1(props.rows)
        let columns = props.selectColumn
            ? [SelectColumn, ...props.columns]
            : props.columns
        // setTableColumns([...columns, { key: 'Empty', name: '', width: 15, minWidth: 15 }]) 
        setTableColumns(columns)
        setoptionTbaleColumns(columns)
        if (isNull(props.TableName)) {
            setVisibleColumns(columns.map(col => col.key))
            setCopyCols(columns.map(col => col.key))
        } else {
            handleFindGridSettings()
        }
    }, [])
    useEffect(() => {
        //add selectCheckbox column in grid
        let columns = props.selectColumn
            ? [SelectColumn, ...props.columns]
            : props.columns
        // setTableColumns([...columns, { key: 'Empty', name: '', width: 15, minWidth: 15 }]) 
        setTableColumns(columns)
        setoptionTbaleColumns(columns)
        setRow1(props.rows)
    }, [props.columns, props.selectColumn])
    const rowKeyGetter = (row) => {
        return row.id;
    }
    const onRowClick = (row) => {
        // console.log(row);
    }
    const isAtBottom = ({ currentTarget }) => {
        return (
            currentTarget.scrollTop + 10 >=
            currentTarget.scrollHeight - currentTarget.clientHeight
        )
    }
    const handleScroll = async (event) => {
        let newRows = [...previousRows, ...props.rows]
        if (rows?.length !== 0) {
            if (loadingMoreRows || !isAtBottom(event)) {
                setNoRows(false)
            } else if (newRows.length !== props.totalCount) {
                setLoadingMoreRows(true)
                // let getRowsLength = rows.length + props.pageSize
                setPreviousRows(newRows)
                setPageNo(pageNo + 1)
                await props.getMoreRows(pageNo + 1)
            } else {
                setLoadingMoreRows(false)
                setNoRows(true)
            }
        }
    }
    //  check is column Date or not
    const checkFieldType = (columnCellValue) => {
        var date = Date.parse(columnCellValue)
        if (isNaN(date)) return false
        else return true
    }
    // call when rows and sortColumn values change
    let sortedRows = useMemo(() => {

        setLoadingMoreRows(false)
        if (sortColumns.length === 0) {
            if (props.onScrollPagination) {
                return [...previousRows, ...props.rows]
            } else {
                return props.rows
            }
        }
        let previousIndex = ''
        let nextIndex = ''
        const comparer = (a, b) => {
            let isDateColumn = false
            //////// For Link Fields ////////
            if (
                !isNull(b[sortColumns[0].columnKey]) &&
                !isNull(b[sortColumns[0].columnKey].props)
            ) {
                isDateColumn = checkFieldType(b[sortColumns[0].columnKey].props.title)
                if (isDateColumn === true) {
                    previousIndex = new Date(a[sortColumns[0].columnKey].props.title)
                    nextIndex = new Date(b[sortColumns[0].columnKey].props.title)
                } else {
                    previousIndex = isNull(a[sortColumns[0].columnKey].props.title)
                        ? ''
                        : a[sortColumns[0].columnKey].props.title
                    nextIndex = isNull(b[sortColumns[0].columnKey].props.title)
                        ? ''
                        : b[sortColumns[0].columnKey].props.title
                }
                if (sortColumns[0].direction === 'ASC') {
                    return previousIndex > nextIndex ? 1 : -1
                } else if (sortColumns[0].direction === 'DESC') {
                    return previousIndex < nextIndex ? 1 : -1
                }
            }
            //////// For simple Fields////////
            else {
                isDateColumn = checkFieldType(b[sortColumns[0].columnKey])
                if (isDateColumn === true) {
                    previousIndex = new Date(a[sortColumns[0].columnKey])
                    nextIndex = new Date(b[sortColumns[0].columnKey])
                } else {
                    previousIndex = isNull(a[sortColumns[0].columnKey])
                        ? ''
                        : a[sortColumns[0].columnKey]
                    nextIndex = isNull(b[sortColumns[0].columnKey])
                        ? ''
                        : b[sortColumns[0].columnKey]
                }
                if (sortColumns[0].direction === 'ASC') {
                    return previousIndex > nextIndex ? 1 : -1
                } else if (sortColumns[0].direction === 'DESC') {
                    return previousIndex < nextIndex ? 1 : -1
                }
            }
        }
        let filterRows = props.onScrollPagination
            ? [...previousRows, ...props.rows]
            : rows
        const sortRows =
            sortColumns.direction === 'NONE' ? filterRows : filterRows.sort(comparer)

        return sortRows
    }, [props.rows, sortColumns])
    const highlightClassname = () => {
        return "row-bg";
    }

    // Colums setting
    const [showCol, setShowCol] = useState(false)
    const [selectAll, setSelectAll] = useState(true)
    const [isLessCol, setIsLessCol] = useState(false)
    const handleColumnsChange = (newColumns) => {
        setTableColumns(newColumns);
    };

    const handleCheckboxChange = (columnKey) => {
        let visisbleCopy = [copyCols]
        if (copyCols.includes(columnKey)) {
            // Column is currently visible, so hide it
            // setVisibleColumns(visibleColumns.filter(key => key !== columnKey));
            setCopyCols(copyCols.filter(key => key !== columnKey));
            visisbleCopy = copyCols.filter(key => key !== columnKey)
        } else {
            // Column is currently hidden, so show it
            // setVisibleColumns([...visibleColumns, columnKey]);
            setCopyCols([...copyCols, columnKey]);
            visisbleCopy = [...copyCols, columnKey]
        }

        // if (visisbleCopy.length < tableColumns.length) {
        //     setIsLessCol(true)
        // }
        setSelectAll(false)
    };
    // const handleShowAllColumns = () => {
    //     setVisibleColumns(tableColumns.map(column => column.key));
    // };
    // const handleHideAllColumns = () => {
    //     setVisibleColumns([]);
    // };
    const handleSelectAll = (e) => {
        if (e.target.checked === false) {
            // setVisibleColumns([]);
            setCopyCols([]);
        } else {
            // setVisibleColumns(tableColumns.map(column => column.key));
            setCopyCols(tableColumns.map(column => column.key));
        }
        setSelectAll(!selectAll)
    }
    useEffect(() => {
        // Initialize Select All based on the initial state of copyCols
        setSelectAll(copyCols?.length === tableColumns?.length);
    }, [copyCols]);
    useEffect(() => {

    }, [isLessCol])


    const handleApplyChanges = () => {
        setIsLessCol(true)
        setVisibleColumns([...copyCols])
        setShowCol(false)
        setoptionTbaleColumns(props.columns)
    }
    const handleSearchColumns = (e) => {
        const value = e.target.value.toLowerCase().trim();
        if (!value) {
            // If the search query is empty, show all columns
            setoptionTbaleColumns(props.columns)
            return;
        }
        const filteredColumns = props.columns.filter(column => {
            if (column?.name?.props?.headerName) {
                return column.name.props.headerName.toLowerCase().includes(value);
            } else if (column?.name) {
                return column.name.toLowerCase().includes(value);
            }
            return filteredColumns;
        });
        setoptionTbaleColumns(filteredColumns)
    };

    const handleDefaultSetting = () => {
        setCopyCols(tableColumns.map(column => column.key));
        setIsLessCol(false)
        setSelectAll(true)
    }
    const handleSaveGridSettings = () => {
        setIsLessCol(true)
        setVisibleColumns([...copyCols])
        let saveColumns = copyCols.join(', ')
        ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', {
            "TableName": enumUtil.enumAPITableName.GridSettings,
            "ID": ColumnID,
            "Data": {
                "TableName": props.TableName,
                "ColumnNames": saveColumns
            }
        }).then((response) => {
            setShowCol(false)
            setoptionTbaleColumns(props.columns)
        }).catch((error) => {
            setShowCol(false)
        })

    }
    const handleFindGridSettings = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/FindByID", 'post', {
            "TableName": enumUtil.enumAPITableName.GridSettings,
            "SearchParam": props.TableName
        }).then((response) => {
            setIsLoading(false)
            setColumnID(response.GridsettingsID + "")
            setColumnNames(response.ColumnNames)
            const array = response.ColumnNames.split(', ');
            setVisibleColumns(array)
            setCopyCols(array)
        }).catch((error) => {
            setIsLoading(false)
            setVisibleColumns(props.columns.map(col => col.key))
            setCopyCols(props.columns.map(col => col.key))

        })
    }
    const columnsCheckboxList = (
        <div className={`ar_hide_column_popup ${props.colPopup ? props.colPopup : ''}`}>
            <div className='ar_header d-flex align-items-center justify-content-between'>
                <p className='ar-light-color xsm_heading fs-12'>Hide Column</p>
                <div className='d-flex align-items-center gap-2'>
                    <span className='save default' onClick={handleDefaultSetting}>
                        <i className='icon-Icon-awesome-sync-alt cursor-pointer fs-12'></i>
                        <p class="tool_tip xsm_text text-light">Default</p>
                    </span>
                    <span className='save' onClick={() => handleSaveGridSettings()}>
                        <i className="icon-Vector5 cursor-pointer fs-12" />
                        <p class="tool_tip xsm_text text-light">Save & Apply</p>
                    </span>
                    <span className='apply'>
                        <i className="icon-apply-all cursor-pointer fs-12" onClick={() => handleApplyChanges()} />
                        <p class="tool_tip xsm_text text-light">Apply</p>
                    </span>
                    <span className='save' onClick={() => setShowCol(false)}>
                        <i className="icon-close cursor-pointer fs-12" />
                    </span>
                </div>
            </div>
            <div className='ar_content pb-0 px-0'>
                <div className='ar-input pb-2 px-10'>
                    <input
                        type="text"
                        className="form-control w-100"
                        name="search"
                        id="search"
                        variant="outlined"
                        placeholder='Search..'
                        onChange={handleSearchColumns}
                    />
                    <i className='icon-Clip-path-group'></i>
                </div>
                <div className='d-flex flex-column gap-1 ar_custom_scrolbar px-10'>
                    <div className='d-flex align-items-center gap-1'>
                        <div className="custom_check_box">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={selectAll}
                                onChange={handleSelectAll}
                            />
                        </div>
                        <span className="font_m"> Select All</span>
                    </div>
                </div>
                <div className='d-flex flex-column gap-1 ar_custom_scrolbar px-10'>
                    {optionTbaleColumns.map(column => (
                        <div
                            key={column.key}
                            className={`d-flex align-items-center gap-1 ${copyCols?.some(
                                (selectedItem) =>
                                    selectedItem?.value === column?.value
                            )
                                ? "selected"
                                : ""
                                }`}>
                            <div className="custom_check_box">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={copyCols && copyCols.includes(column.key)}
                                    onChange={() => handleCheckboxChange(column.key)}
                                />
                            </div>
                            <span className="font_m"> {column?.name?.props?.headerName ? ' ' + column?.name?.props?.headerName : !isNull(column.name) ? ' ' + column.name : 'Options'}</span>
                        </div>
                    ))}
                </div>
            </div>
            {/* <div className='d-flex justify-content-between cursor-pointer pb-2 pt-1 px-10'>
                <p className='heading text-primary' onClick={handleHideAllColumns}> HIDE All</p>
                <p className='heading text-primary cursor-pointer' onClick={handleShowAllColumns}>SHOW ALL</p>
            </div> */}
        </div>
    );
    return (
        <React.Fragment>
            {props.hideColClass !== 'hide' && (  // Replace 'hide' with the value that should hide the icon
                <span className={`bg-transparent ar-hide-button px-1 mt-0-5 ${props.hideColClass ? props.hideColClass : ''}`} onClick={() => setShowCol(!showCol)}>
                    <div className="app_tooltip left">
                        <i className='icon-HIDE-COLUMN-ICON cursor-pointer fs-18'></i>
                        <p class="tool_tip xsm_text text-light">Hide Columns</p>
                    </div>
                </span>
            )}
            {(props.TableName === 'Location' || props.TableName === 'Provider' || props.TableName === 'RefProvider') ? (isLoading ? <Loader /> : null) : null}
            {showCol ? columnsCheckboxList : null}
            <ReactDataGrid
                key={Row1 || props.key || props.bottomSummaryRows}
                enableVirtualization={true}
                columns={tableColumns ? tableColumns.filter(column => visibleColumns?.includes(column.key)) : []}
                rows={Row1}
                onRowChange={props.onRowChange}
                sortColumns={sortColumns}
                onSortColumnsChange={setSortColumns} // set column and  direction to sortColumns
                components={{ noRowsFallback: <EmptyRowsRenderer /> }} // will return empty row message in Grid 
                selectedRows={props.selectedRows}
                onSelectedRowsChange={props.onSelectedRowsChange}
                rowKeyGetter={rowKeyGetter} // is required to get row key for selectcolumn
                onRowClick={onRowClick}
                onColumnsChange={handleColumnsChange}
                bottomSummaryRows={props.bottomSummaryRows} //sticky footer
                defaultColumnOptions={{ resizable: true }}
                onScroll={props.onScrollPagination ? handleScroll : null}
                style={{
                    width: props.width ? props.width : '100%',
                    height: Row1?.length === 0 ? '100px' : (isNull(props.height) ? 'auto' : props.height),
                    // height: Row1.length === 0 ? '100px' : props.height,
                    maxHeight: props.height ? props.height : '330px',
                    overflowY:
                        !props.onScrollPagination && rows?.length <= 10 ? 'hidden' : '',
                    userSelect: 'text',
                    fontSize: '13px'
                }}
                rowHeight={props.rowHeight ? props.rowHeight : 30}
                className={
                    (GridView?.GridView === 'Borderless Grid' || GridView?.GridView === 'BorderlessGrid')
                        ? `serviceline-grid ${props.dynamicClass}${isLessCol ? ' hide-coulomn-check' : ''}`
                        : `${props.dynamicClass}${isLessCol ? ' hide-coulomn-check' : ''}`
                }

                // className={isLessCol ?  ${props.dynamicClass} ${'hide-coulomn-check'} :   props.dynamicClass} 
                rowClass={props.rowClass ? props.rowClass : undefined}
                onRowsChange={props.onRowsChange}
                headerRowHeight={props.headerRowHeight}
            />
            {
                loadingMoreRows && (
                    <div
                        style={{
                            width: ' 180px',
                            padding: '8px 16px',
                            position: 'absolute',
                            bottom: '8px',
                            right: '8px',
                            color: 'white',
                            lineHeight: '35px',
                            background: 'rgb(0 0 0 / 0.6)',
                        }}
                    >
                        Loading More Rows...
                    </div>
                )
            }
            {
                noRows && (
                    <div
                        style={{
                            width: ' 180px',
                            padding: '8px 16px',
                            position: 'absolute',
                            bottom: '8px',
                            right: '8px',
                            color: 'white',
                            lineHeight: '35px',
                            background: 'rgb(0 0 0 / 0.6)',
                        }}
                    >
                        No more rows
                    </div>
                )
            }
            {/* {props.isLoading ? null :
                props.rows?.length === 0 ?
                    <div className='no_data'>
                        <div>
                            <img src={NoDataFound} />
                            <p>No Data Found</p>
                        </div>
                    </div> : null
            } */}
            <NoDataFound isLoading={props.isLoading} rows={props.rows} />
        </React.Fragment>
    )
}
export default DataTable

function EmptyRowsRenderer() {
    return (
        <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
            <Loader></Loader>
        </div>
    );
}